import request from '@/utils/request'

/**
 * @description 通用图片上传接口
 * @param data
 */
export function uploadImg(data) {
  const config = {}
  if (process.env.NODE_ENV === 'development') {
    const safeDomain = request.defaults.__webConfig.SAFE_DOMAIN
    config.baseURL = '//' + safeDomain
  }
  // 限制最大5MB
  if (data) {
    data.maxsize = 5
  } else {
    data = { maxsize: 5 }
  }
  return request.post('/phalapi/public/?service=App.Common.SaveImg', data, config)
}

/**
 * @description 获取图片列表
 * @param data
 * @returns {*}
 */
export function getMaterialList(data) {
  return request.post('/phalapi/public/?service=App.Common.GetMaterialsList', data)
}

/**
 * @description 保存图片信息
 * @param data
 * @returns {*}
 */
export function saveMaterialInfo(data) {
  return request.post('/phalapi/public/?service=App.Common.EditMaterials', data)
}

/**
 * @description 获取图片分组列表
 * @param data
 * @returns {*}
 */
export function getMaterialGroupList(data) {
  return request.post('/phalapi/public/?service=App.Common.GetAllMaterialsCategory', data)
}

/**
 * @description 保存图片分组信息
 * @param data
 * @returns {*}
 */
export function saveMaterialGroup(data) {
  return request.post('/phalapi/public/?service=App.Common.AddOrEditMaterialCategory', data)
}

/**
 * @description 删除图片分组
 * @param data
 * @returns {*}
 */
export function deleteMaterialGroup(data) {
  return request.post('/phalapi/public/?service=App.Common.DelMaterialCategory', data)
}

/**
 * @description 修改分类下全部图片分类
 * @param data
 * @returns {*}
 */
export function batchChangeGroup(data) {
  return request.post('/phalapi/public/?service=App.Common.ToggleMaterialsCategory', data)
}

/**
 * @description 删除图片
 * @param data
 * @returns {*}
 */
export function deleteMaterial(data) {
  return request.post('/phalapi/public/?service=App.Common.DelMaterials', data)
}
